export const locale = {
  lang: 'en',
  data: {
    'SEARCH': {
      'PLACEHOLDER':'Search ...'
    }
  }
};
